import { render, staticRenderFns } from "./PayeeInfoView.vue?vue&type=template&id=f3b47244&scoped=true&"
import script from "./PayeeInfoView.vue?vue&type=script&lang=ts&"
export * from "./PayeeInfoView.vue?vue&type=script&lang=ts&"
import style0 from "./PayeeInfoView.vue?vue&type=style&index=0&id=f3b47244&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b47244",
  null
  
)

export default component.exports